module.exports = __webpack_public_path__ + "img/jingdo.530c4fe6.webp";